export default function FavoriteIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12658 5.97054C5.95075 5.08867 4.30539 5.2056 3.26609 6.2449C2.11269 7.3983 2.11269 9.26833 3.26609 10.4217L8.28073 15.4364C9.22979 16.3854 10.7685 16.3854 11.7176 15.4364L16.7322 10.4217C17.8856 9.26833 17.8856 7.3983 16.7322 6.2449C15.6929 5.2056 14.0476 5.08867 12.8717 5.97054L10.7064 7.59456C10.2873 7.90888 9.71103 7.90888 9.29193 7.59456L7.12658 5.97054ZM2.08758 5.06639C3.71336 3.4406 6.28721 3.25768 8.12658 4.63721L9.99916 6.04165L11.8717 4.63721C13.7111 3.25768 16.285 3.4406 17.9107 5.06639C19.715 6.87066 19.715 9.79596 17.9107 11.6002L12.8961 16.6149C11.2962 18.2148 8.70216 18.2148 7.10222 16.6149L2.08758 11.6002C0.283307 9.79597 0.283306 6.87066 2.08758 5.06639Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
